import { twMerge } from "tailwind-merge";

// TODO(Cycle 12): 実データ接続時に next/image (sizes prop 付き) へ置き換える。
// twMerge は base の w-full と呼び出し側の w-[..] / size-[..] の衝突を解決するため (clsx 不可)。
export function DxImagePlaceholder({
  className,
  label,
  aspectRatio,
}: {
  className?: string;
  label?: string;
  /** 縦横比指定。 指定しない場合は className 側で h-[...] 等を指定する。 */
  aspectRatio?: string;
}) {
  return (
    <div
      style={aspectRatio !== undefined ? { aspectRatio } : undefined}
      className={twMerge(
        "bg-dx-surface-subtle text-dx-text-muted flex w-full items-center justify-center overflow-hidden",
        className,
      )}
      aria-hidden
    >
      {label !== undefined && (
        <span className="font-dx text-[10px] tracking-widest uppercase">
          {label}
        </span>
      )}
    </div>
  );
}
